import React from "react";
import { connect } from "react-redux";
import Target from "./Target";
import { Card } from "react-bootstrap";
import { ConvertTagsToHtml } from "../helpers/TagHelper";

const SourceControl = ({ segment, sgm }) => {
  return (
    <tr className="segment row gx-0 gy-5">
      <td className="col">
        <Card>
          <Card.Body
            dangerouslySetInnerHTML={{ __html: segment.SourceTextHtml }}
          >
            {/* {segment.sourceText} */}
          </Card.Body>
        </Card>
      </td>
      <td className="col">
        <Target segment={segment}> </Target>
      </td>
    </tr>
  );
};

export default SourceControl;
